import React from "react";
import { Link } from "react-router-dom";
import { IDog } from "@eagerdog/interfaces";

import styles from "./DogItem.module.scss";

interface IProps {
  dog: IDog;
}

const DogItem: React.FC<IProps> = ({ dog }) => {
  const name = dog.call_name || dog.registered_name || "Dog";

  return (
    <li className={styles.DogItem}>
      <Link to={`/dogs/${dog._id}`} className={styles.link}>
        <div className={styles.portrait}>
          {dog.image_url ? (
            <img src={dog.image_url} alt={name} />
          ) : (
            <span className={styles.fallback}>{name.charAt(0).toUpperCase()}</span>
          )}
        </div>
        <span className={styles.name}>{name}</span>
      </Link>
    </li>
  );
};

export default DogItem;
